module.exports = __webpack_public_path__ + "static/media/logo.ffebd9ea.png";